import { NOTIFICATION_TYPE } from "../const/const";
/** Loại thông báo chat — chỉ hiển thị tab Hoạt động (MessageSideBar), không vào topbar. */
export const TOPBAR_EXCLUDED_NOTIFICATION_TYPES = [
    NOTIFICATION_TYPE.CREATE_MESSAGE_CHAT,
    NOTIFICATION_TYPE.REACTION_MESSAGE_CHAT,
];
export function isTopbarNotificationType(type) {
    if (type == null || type === "") {
        return true;
    }
    return !TOPBAR_EXCLUDED_NOTIFICATION_TYPES.includes(String(type));
}
export function filterTopbarNotifications(items) {
    if (!Array.isArray(items)) {
        return [];
    }
    return items.filter((item) => isTopbarNotificationType(item?.type));
}
